export const nightTransferList = [
  {
    title: 'transfer_details.night_transfer.first_item.title',
    description: 'transfer_details.night_transfer.first_item.description',
  },
  {
    title: 'transfer_details.night_transfer.second_item.title',
    description: 'transfer_details.night_transfer.second_item.description',
  },
  {
    title: 'transfer_details.night_transfer.third_item.title',
    description: 'transfer_details.night_transfer.third_item.description',
  },
  {
    title: 'transfer_details.night_transfer.fourth_item.title',
    description: 'transfer_details.night_transfer.fourth_item.description',
  },
]
